import { UserRole } from '../types';

export interface RoleAccentStyles {
  headerLine: string;
  headerGlow: string;
  sidebarLine: string;
  sidebarGlow: string;
}

/**
 * Universal Bloom Visual Canon:
 * Roles are communicated through text, permissions, and workflow — not decorative recoloring.
 * Edges and glows are neutral and restrained across all roles.
 */
export function getRoleAccentStyles(_role?: UserRole | string): RoleAccentStyles {
  return {
    headerLine: '',
    headerGlow: '',
    sidebarLine: '',
    sidebarGlow: '',
  };
}

export interface RoleEntitlementStyles {
  activeContainer: string;
  inactiveContainer: string;
  activeIcon: string;
  inactiveIcon: string;
  activeCheck: string;
}

/**
 * Universal Canon for Role Entitlements controls:
 * Clean neutral light work surfaces and crisp charcoal/slate text.
 */
export function getRoleEntitlementStyles(_role: string): RoleEntitlementStyles {
  return {
    activeContainer:
      'bg-slate-100 text-slate-900 border-slate-400 font-semibold shadow-xs',
    inactiveContainer:
      'bg-white text-slate-600 border-slate-200 hover:border-slate-300 hover:text-slate-900 hover:bg-slate-50',
    activeIcon: 'text-slate-800',
    inactiveIcon: 'text-slate-400 group-hover:text-slate-600',
    activeCheck: 'text-slate-900',
  };
}

/**
 * Universal Canon for Role Badges:
 * Neutral slate/charcoal badges across all roles.
 */
export function getRoleBadgeClasses(_role: string): string {
  return 'bg-slate-100 hover:bg-slate-200/80 text-slate-800 border border-slate-300 shadow-xs font-semibold';
}

/**
 * Universal Bloom Visual Canon for Primary Action (Start Speech):
 * - deep slate-blue / navy fill
 * - white text
 * - white or soft-slate play icon
 * - crisp slate border
 * - subtle neutral shadow only
 * - restrained hover/pressed state
 */
export const START_SPEECH_PRIMARY_ACTION_STYLE =
  'bg-slate-800 hover:bg-slate-700 active:bg-slate-900 text-white border border-slate-700 shadow-xs transition-colors active:scale-98 cursor-pointer shrink-0';


